document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.shopify-policy__container');
  const title = document.querySelector('.shopify-policy__title h1');

  if (!container || !title) return;

  const path = window.location.pathname.replace(/\/+$/, '');

  const titleMap = {
    '/policies/refund-policy': 'Returns & Sizing',
    '/policies/shipping-policy': 'Shipping',
    '/policies/privacy-policy': 'Privacy Policy',
    '/policies/terms-of-service': 'Terms of Service'
  };

  if (titleMap[path]) {
    title.textContent = titleMap[path];
  }

  const close = document.createElement('button');
  close.type = 'button';
  close.className = 'szn-policy-close';
  close.setAttribute('aria-label', 'Close policy page');
  close.innerHTML = '&times;';

  close.addEventListener('click', function () {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = '/';
    }
  });

  container.prepend(close);
});